<template>
    <el-form ref="loginForm" class="login-form" auto-complete="on" label-position="left">
        <div class="title-container">
            <h3 class="title">
                관리자 로그인
            </h3>
        </div>
        <el-form-item>
        <span class="svg-container">
          <i class="el-icon-user-solid"></i>
        </span>
            <el-input
                    name="loginForm"
                    v-model="id"
                    type="text"
                    auto-complete="on"
            />
        </el-form-item>

        <el-form-item >
        <span class="svg-container">
          <i class="el-icon-lock"></i>
        </span>
            <el-input
                    name="mb_password"
                    v-model="password"
                    type="password"
                    auto-complete="on"
                    @keyup.enter.native="userLogin"
            />

        </el-form-item>
        <div class="login_find_link_wrap text_center">
        </div>
        <el-button type="primary" style="width:100%;margin-bottom:10px;" @click="userLogin">
            로그인
        </el-button>
    </el-form>
</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import {loginTokenSet, getTokenObj} from "@/mixins/Auth";
import memberValidator from "@/mixins/validators/memberValidator"
import util from "@/mixins/util";
import {LevelClass} from "@/mixins/level";

export default {
    name: "LoginComponent",
    mixins: [memberValidator,alertMixins],
    components: {
    },
    props: {
    },
    data() {
        return{
            showPwd: false,
            redirect: '/',
            LevelClass: new LevelClass(),
        }
    },
    created() {
        this.redirect = (this.$route.query.redirect) ? this.$route.query.redirect : '/';
    },
    mounted() {

    },
    computed: {
    },
    methods:{
        async userLogin() {
            if (!this.$validate(['id', 'password'])) {
                return;
            }

            let params = {
                mb_id: this.id,
                mb_password: this.password,
                m_type: 'admin'
            }
            try {
                await this.$api.$auth.login(params).then( (res) =>  {
                    let ret =  res.Data.Result;
                    let result = this.returnLoginTypeAlertTxt(ret.Info.type)
                    if(result === true) {
                        loginTokenSet(ret.List);
                        this.checkLevel();
                        // this.$router.push(this.redirect);
                    }else{
                        this.errorAlert(result);
                    }
                })

            }catch (e) {
                console.log(e);
            }
        },
        checkLevel() {
            let tokenObj = getTokenObj();
            this.$api.$config.getGroup().then(res => res.Data.Result).then(res => {
                if (res.Info.type != 1 || util.isEmpty(tokenObj.g_idx)) {
                    this.checkLevelFail();
                } else {
                    let g_idx = tokenObj.g_idx;
                    let groupList = res.List;
                    this.makeGroupObj(g_idx, groupList);
                }

            });
        },
        checkLevelFail(errorMsg = '로그인에 실패하였습니다.') {
            this.errorMsg = errorMsg;
            this.errorAlert(errorMsg)
            loginTokenSet('');
            this.$localStorage.remove('token');
        },
        checkLevelSuccess(levelObj) {
            this.LevelClass.setterLevelObj(levelObj);
            this.$router.push(this.redirect);
        },
        makeGroupObj(g_idx, groupList) {
            let groupIndex = groupList.findIndex(group => group.g_idx === g_idx);
            console.log(groupIndex)

            if (groupIndex < 0) {
                this.checkLevelFail();
            } else if(groupIndex == 5){
                this.checkLevelFail('밍글패스 관리자는 로그인을 할 수 없습니다.');
            } else {
                let levelObj = {
                    level: groupList[groupIndex].g_level,
                    type: groupList[groupIndex].g_type,
                    isSuper: groupList[groupIndex].g_is_super === 1 ? true : false,
                }
                this.checkLoginLevel(levelObj);
            }
        },
        checkLoginLevel(levelObj) {
            if (levelObj.type === 'admin') {
                this.checkLevelSuccess(levelObj);
            } else {
                this.checkLevelFail('일반회원은 로그인을 할 수 없습니다.');
            }
        },
        returnLoginTypeAlertTxt(type) {
            switch (type) {
                case 1:
                    return true;
                case -3:
                    return '해당하는 회원이 없습니다. 아이디를 다시 확인해주세요.';
                case -100:
                    return '비밀번호가 틀렸습니다. 비밀번호를 다시 확인해주세요.';
                default:
                    return '아이디와 비밀번호를 다시 입력해주세요.';
            }
        },
    },
    watch: {

    },
}
</script>

<style scoped>

</style>
